export default "__VITE_ASSET__TD9N3ArQ__"